import React from 'react';
import PropTypes from 'prop-types';

import { useInterval } from '@tzmedical/react-hooks';

import axios from '../axiosClient.js';

const PermissionsContext = React.createContext();
const REFRESH_INTERVAL_MS = 300_000;

export function PermissionsProvider({ children }) {
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [permissions, setPermissions] = React.useState([]);

  const checkPermissions = React.useCallback(async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: '/api/permissions',
      });

      if (data.length === 0) {
        setError('No user permissions found');
        setPermissions([]);
        setLoading(false);
        return;
      }

      setPermissions(data);
      setError(null);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      setLoading(false);
    }
  }, []);

  useInterval(checkPermissions, REFRESH_INTERVAL_MS, loading && !error);

  const value = React.useMemo(
    () => ({
      permissions,
      error,
      loading,
      refreshPermissions: checkPermissions,
    }),
    [permissions, error, loading, checkPermissions]
  );

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
}

PermissionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PermissionsContext;
